module.exports = __webpack_public_path__ + "img/logo_zoox.b781c925.png";